import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { useAppConfig } from './useAppConfig';

export const useAppInfo = () => {
  const { appConfig, featureFlags, config } = useConfigStore.getState();
  const { isCleengSubscriptionEnabled } = useAppConfig();
  const isUser = localStorage.getItem('jwapp.auth') || localStorage.getItem('access_token') || localStorage.getItem('inplayer_token');
  const configId = featureFlags?.jwplayer?.config_id;
  const clientId = featureFlags?.inplayer?.client_id;
  const clientSite = appConfig?.branding?.client_site;
  const appVersion = featureFlags?.platforms?.web?.latest_version;
  const supportEmail = featureFlags?.common?.app_data?.support_email;
  const supportEmailType = featureFlags?.common?.app_data?.support_email_type;
  const supportLabel = featureFlags?.common?.app_data?.support_label;

  const availableLanguages = featureFlags?.common.supported_languages;

  const termsOfUse = featureFlags?.common?.legal_docs?.terms_of_use;
  const privacyPolicy = featureFlags?.common?.legal_docs?.privacy_policy;
  const videoConsentViewingPolicy = featureFlags?.common?.legal_docs?.video_consent_viewing_policy;
  const dmcaNotice = featureFlags?.common?.legal_docs?.dmca_notice;
  const doNotSellOrShare = featureFlags?.common?.legal_docs?.do_not_sell_or_share;
  const aboutUs = featureFlags?.common?.legal_docs?.aboutUs;

  const landscapeThumbnail = appConfig?.branding?.video_horizontal_thumbnail;
  const portraitThumbnail = appConfig?.branding?.video_vertical_thumbnail;

  const domain = appConfig?.branding?.domain;
  const packageKey = isCleengSubscriptionEnabled
    ? config.integrations.cleeng?.useSandbox
      ? featureFlags?.subscription?.product_id_keys?.staging
      : featureFlags?.subscription?.product_id_keys?.production
    : config.integrations.jwp?.useSandbox
    ? featureFlags?.subscription?.product_id_keys?.staging
    : featureFlags?.subscription?.product_id_keys?.production;

  const mobileAppsLinks = appConfig?.footer?.mobile_apps_links;

  return {
    clientSite,
    supportEmail,
    supportEmailType,
    supportLabel,
    availableLanguages,
    termsOfUse,
    privacyPolicy,
    videoConsentViewingPolicy,
    dmcaNotice,
    doNotSellOrShare,
    aboutUs,
    landscapeThumbnail,
    portraitThumbnail,
    configId,
    clientId,
    appVersion,
    isUser,
    domain,
    packageKey,
    mobileAppsLinks,
  };
};
